import { render, staticRenderFns } from "./index.vue?vue&type=template&id=fff2a80c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=fff2a80c&prod&lang=stylus&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=fff2a80c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fff2a80c",
  null
  
)

export default component.exports